import React, { useState, useEffect } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { ISupervisores } from "../../../Interfaces/IListaVerificacion";
import personaServicio from "../../../services/persona/personaServicio";
import {
  _initialFilter,
  _initialPagination,
  _onRenderHeader,
} from "../../../utils/helpers/helpers";
import { IColumn } from "@fluentui/react/lib/DetailsList";
import {
  Icon,
  IComboBox,
  TooltipHost,
  ICommandBarItemProps,
  Stack,
} from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useBoolean } from "@fluentui/react-hooks";
import IconHelper from "../../../utils/helpers/iconHelper";
import COLORES from "../../../utils/theme/colores";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PanelFilterSupervisore } from "./PanelFilterSupervisore";
import { PanelRegistrarSuplente } from "./PanelRegistrarSuplente";
import { PanelEquipoTrabajoBySupervisor } from "./PanelEquipoTrabajoBySupervisor";
import { IDataSupersivor } from "../../../Interfaces/IPersona";
import { useTableSupervisores } from "../../../hooks/TablasHooks/useTableSupervisores";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { PanelCargaMasivaSupervisores } from "./PanelCargaMasivaSupervisores/PanelCargaMasivaSupervisores";

const classNames = mergeStyleSets({
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});

function ListadoSupervisores() {
  const [
    isOpenPanelFilter,
    { setTrue: openPanelFilter, setFalse: onDismissFilter },
  ] = useBoolean(false);
  const [
    openPanelCargaMasivaSupervisores,
    { setTrue: openCargaMasivaSupervisores, setFalse: dismissCargaMasivaSupervisores }
  ] = useBoolean(false);
  const [
    isOpenEquipo,
    { setTrue: openPanelEquipo, setFalse: dismissPanelEquipo },
  ] = useBoolean(false);

  const [
    isOpenPanelSuplente,
    { setTrue: openPanelSuplente, setFalse: dismissPanelSuplente },
  ] = useBoolean(false);

  const [dataSupervisor, setDataSupervisor] = useState<IDataSupersivor>(null!);
  const [itemSelect, setItemSelect] = useState<ISupervisores>();

  const {
    _onkeyUpSearch,
    dataTable,
    isLoading,
    onChangeSkip,
    searchBoxRefTable,
    paginacion,
    refreshTable,
    filter,
    setFilter
  } = useTableSupervisores();

  const _itemsLeftBar: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        refreshTable();
      },
    },
    {
      ...IconHelper.ICON_CARGAMASIVA,
      onClick: () => {
        openCargaMasivaSupervisores();
      },
    }
  ];

  const _itemsRigthBar: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BS_FILTER,
      onClick: () => {
        openPanelFilter();
      },
    },
  ];


  const _columns: IColumn[] = [
    {
      key: "persona",
      name: "Persona",
      fieldName: "persona",
      minWidth: 240,
      maxWidth: 240,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "tipoDocumentoIdentidad",
      name: "Tipo Documento",
      fieldName: "tipoDocumentoIdentidad",
      minWidth: 70,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "nroDOI",
      name: "DNI",
      fieldName: "nroDOI",
      minWidth: 90,
      maxWidth: 95,
      isResizable: true,
    },
    {
      key: "empresa",
      name: "Empresa",
      fieldName: "empresa",
      minWidth: 170,
      maxWidth: 170,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "puesto",
      name: "Puesto",
      fieldName: "puesto",
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "rol",
      name: "Rol",
      fieldName: "rol",
      minWidth: 120,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item: ISupervisores) => (
        <>
          <TooltipHost content={"Equipo de trabajo"}>
            <Icon
              iconName="Group"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: COLORES.Bases.primary }}
              onClick={() => {
                setItemSelect(item);
                openPanelEquipo();
              }}
            />
          </TooltipHost>

          <TooltipHost content={"Registrar Suplente"}>
            <Icon
              iconName="AddFriend"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: COLORES.Bases.primary }}
              onClick={() => {
                setDataSupervisor({
                  ...dataSupervisor,
                  supervisorId: item.supervisorId,
                  nombreSupervisor: item.persona,
                });
                openPanelSuplente();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Nombre/DNI"
            Titulo="Supervisores"
            SubTitulo="Gestión de Supervisores"
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearch}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          rigthBar={_itemsRigthBar}
          leftBar={_itemsLeftBar}
          data={dataTable}
          column={_columns}
          isLoading={isLoading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <PanelFilterSupervisore
        isOpen={isOpenPanelFilter}
        onDismiss={onDismissFilter}
        limpiarFiltro={() => {}}
        getter={filter}
        setter={setFilter}
      />
      <PanelRegistrarSuplente
        isOpen={isOpenPanelSuplente}
        onDismiss={dismissPanelSuplente}
        supervisor={dataSupervisor}
      />
      <PanelCargaMasivaSupervisores
        isOpen={openPanelCargaMasivaSupervisores}
        onDismiss={dismissCargaMasivaSupervisores}
        reload={() => {}}
      />
      <PanelEquipoTrabajoBySupervisor
        isOpen={isOpenEquipo}
        onDismiss={dismissPanelEquipo}
        itemSelect={itemSelect}
      />
    </>
  );
}

export default ListadoSupervisores;
